import type { SWRConfiguration } from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import useOrg from './useOrg';
import './_typedef';

/**
 * Uses the SWR library to fetch org data of the current user.
 * @param {Object?} swrOptions - generally optional. See: https://swr.vercel.app/docs/options
 * @returns {SwrOrg}
 */
const useCurrentOrg = (swrOptions: SWRConfiguration = {}) =>
  useOrg(useOwnerOrgId(), swrOptions);

export default useCurrentOrg;
